import React, { useState } from "react";
import emailjs from "@emailjs/browser";
import toast from "react-hot-toast";

export default function StudyConsultancySection() {
  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    destination: "",
    agree: false,
  });

  const [loading, setLoading] = useState(false);
  const [phoneError, setPhoneError] = useState("");
  const [successMessage, setSuccessMessage] = useState("");
  const [showSuccessModal, setShowSuccessModal] = useState(false);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;

    if (name === "phone") {
      if (!/^[0-9]{0,10}$/.test(value)) {
        return; // block extra characters
      }
      setPhoneError(""); // clear error while typing
    }

    setFormData({
      ...formData,
      [name]: type === "checkbox" ? checked : value,
    });
  };

  const isValidPhone = (phone) => /^[0-9]{10}$/.test(phone);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!isValidPhone(formData.phone)) {
      setPhoneError("Phone number must be exactly 10 digits.");
      toast.error("Invalid phone number (10 digits required)");
      return;
    }

    if (!formData.agree) {
      toast.error("You must agree to the terms.");
      return;
    }

    setLoading(true);
    setSuccessMessage("");

    emailjs
      .send(
        "service_zrci1ma",
        "template_hjc8m6a",
        {
          ...formData,
          title: " Consultation Request",
        },
        "FBWx68HE_az5_KuQx"
      )
      .then(() => {
        toast.success("Mail sent successfully!");
        
        setSuccessMessage("🎉 Your request has been submitted successfully!");
        setShowSuccessModal(true);
        setFormData({
          name: "",
          phone: "",
          email: "",
          destination: "",
          agree: false,
        });
         setTimeout(() => setShowSuccessModal(false), 3000);
      })
      .catch((err) => {
        console.log("EMAILJS ERROR:", err);
        toast.error("Something went wrong. Try again.");
      })
      .finally(() => setLoading(false));
  };

  return (
    <section className="container bg-white pb-8 px-4 sm:px-8 lg:px-16">
      <div className="max-w-7xl mx-auto flex flex-col lg:flex-row items-start justify-between gap-10 lg:gap-16">

        {/* LEFT SIDE */}
        <div className="w-full lg:w-1/2 space-y-4">
          <h2 className="font-bold leading-snug text-[clamp(1.5rem,4vw,2.5rem)] text-gray-900">
            Start Your Study <span className="text-blue-600">Abroad</span> Journey 
            <br />
            with <span className="text-blue-600">Confidence</span>
          </h2>


          <p className="text-gray-700">
            Dreaming of studying at a top global university? Easylearn Educare guides aspiring students in Kolkata through every step of their study abroad journey. Our experienced counsellors provide end-to-end support—from choosing the right country and university to preparing applications, documentation, and visa assistance.
We collaborate with universities across the USA, UK, Canada, Australia, and Europe, ensuring you find the best program that matches your academic goals and career ambitions. Whether you’re looking for undergraduate, postgraduate, or specialized professional courses, our experts help you navigate complex admission procedures with ease.
          </p>
        </div>

        {/* FORM */}
        <div className="w-full lg:w-1/2 flex justify-center lg:justify-end">
          <div className="w-full max-w-md bg-white border rounded-xl shadow-md p-6 sm:p-8">
            <h3 className="text-lg font-semibold text-gray-900 text-center">
              Book Your <span className="text-blue-600">FREE Consultation</span> Call
            </h3>

            {/* SUCCESS MESSAGE */}
            {successMessage && (
              <p className="text-green-600 text-center mt-4">{successMessage}</p>
            )}

            <form onSubmit={handleSubmit} className="mt-6 space-y-4">

              <input
                type="text"
                name="name"
                placeholder="Full Name *"
                value={formData.name}
                onChange={handleChange}
                className="w-full border rounded-md p-3"
                required
              />

              <div>
                <input
                  type="text"
                  name="phone"
                  placeholder="Mobile Number *"
                  value={formData.phone}
                  onChange={handleChange}
                  className="w-full border rounded-md p-3"
                  required
                />

                {/* PHONE ERROR MESSAGE */}
                {phoneError && (
                  <p className="text-red-500 text-sm mt-1">{phoneError}</p>
                )}
              </div>

              <input
                type="email"
                name="email"
                placeholder="Email ID *"
                value={formData.email}
                onChange={handleChange}
                className="w-full border rounded-md p-3"
                required
              />

              <select
                name="destination"
                value={formData.destination}
                onChange={handleChange}
                className="w-full border rounded-md p-3"
                required
              >
                <option value="">Destination *</option>
                <option>USA</option>
                <option>UK</option>
                <option>Canada</option>
                <option>Australia</option>
                <option>Germany</option>
              </select>

              <label className="flex gap-2 text-sm text-gray-700 items-start">
                <input
                  type="checkbox"
                  name="agree"
                  checked={formData.agree}
                  onChange={handleChange}
                  className="mt-[4px]"
                />
                <span>
                  I agree to Easylearn’s
                  <span className="text-blue-600"> Privacy Policy </span>
                  and
                  <span className="text-blue-600"> Terms & Conditions </span> *
                </span>
              </label>

              <button
                type="submit"
                disabled={loading}
                className="w-full bg-green-500 hover:bg-green-600 transition text-white font-semibold py-3 rounded-md flex items-center justify-center gap-2"
              >
                {loading ? (
                  <span className="animate-spin border-2 border-white border-t-transparent rounded-full w-5 h-5"></span>
                ) : (
                  "Book a FREE Consultation →"
                )}
              </button>

            </form>
          </div>
        </div>

      </div>
      {showSuccessModal && (
  <div className="fixed inset-0 bg-black bg-opacity-50 flex justify-center items-center z-50">
    <div className="bg-white rounded-xl p-8 w-[90%] max-w-sm shadow-xl text-center animate-fadeIn">

      {/* Animated Tick */}
      <svg
        className="w-20 h-20 mx-auto mb-4 text-green-500 animate-check"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        viewBox="0 0 24 24"
      >
        <path
          className="check-path"
          strokeLinecap="round"
          strokeLinejoin="round"
          d="M5 13l4 4L19 7"
        />
      </svg>

      <h2 className="text-xl font-semibold text-gray-800">
        Message Sent Successfully!
      </h2>

      <p className="text-gray-600 mt-2">
        Thank you! We will contact you shortly.
      </p>

      <button
        onClick={() => setShowSuccessModal(false)}
        className="mt-5 px-5 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md"
      >
        Close
      </button>
    </div>
  </div>
)}

    </section>
  );
}
